import {PortExposureChunk} from "../chunks/types/PortExposureChunk";
import {portExposureBodyChunkToChildPortRef} from "./portExposureBodyChunkToChildPortRef";
import {ChildPortRef} from "./types/ChildPortRef";

export function portExposureChunkToChildPortRef(
  portExposureChunk: PortExposureChunk
): ChildPortRef<any, any> {
  const {
    captures: {
      1: portExposureBodyChunk
    }
  } = portExposureChunk
  return portExposureBodyChunkToChildPortRef(portExposureBodyChunk);
}
